<template>
    <div class="component-list">
      <div class="seach-input">
        <el-input :value="formatKeyword"  v-model="keyword" class="input-with-select" clearable></el-input>
        <i class="el-icon-search search" v-show="!display"></i>
      </div>
      <div>
        <el-collapse v-model="activeNames">
          <el-collapse-item  v-for="(list,index) in templateCategories" :key="index" :title="list.name" :name="list.name">
            <ul class="component-ul">
              <li class="component-template" @dblclick="addComponentByDB(template)" v-for='(template, index) in list.components' :key='index' :component-type="template.type" :component-name="template.name">
                <img :src= "template.imgSrc"
                     :alt="template.name"
                     :title="template.name">
                <span class="name">{{ template.name }}</span>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
</template>

<script>
import cache from '../../public/cache'
import interact from 'interactjs'
import { findVueMixin } from '@/components/form/runtime/components/findVue.js'
export default {
  name: 'ComponentList',
  inject: ['formService', 'componentEventBus'],
  props: {
    originalComponent: Object,
    highlightId: String,
    currentNodeFormId: String
  },
  mixins: [findVueMixin],
  data () {
    return {
      activeNames: [],
      templateCategories: [],
      keyword: '',
      currentLayoutComponet: null
    }
  },
  computed: {
    // 监听搜索控件
    formatKeyword () {
      let keyword = this.keyword
      if (keyword) {
        this.getSearchControls(this.templateCategories, keyword)
      } else {
        this.closeSearchControls()
      }
      return keyword
    },
    display () {
      return this.keyword
    }
  },
  created () {
    this.getDataList()
  },
  mounted () {
    interact('.component-template')
      .draggable({
        // 开始拖动时复制dom
        onstart (event) {
          let target = event.target.cloneNode(true)
          let dropLi = event.target
          dropLi.appendChild(target)
        },
        onend (event) {
          let target = event.target.lastChild
          let removeUl = event.target
          removeUl.removeChild(target)
        },
        onmove (event) {
          let target = event.target.lastChild
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
          let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
          // translate the element
          target.style.webkitTransform =
            target.style.transform =
              'translate(' + x + 'px, ' + y + 'px)'
          // update the posiion attributes
          target.setAttribute('data-x', x)
          target.setAttribute('data-y', y)
        }
      })
  },
  methods: {
    getDataList () {
      cache.getDateWithNoparma(`/form-api/components/definitions`).then((data) => {
        // 部分租户用插件请求
        cache.getDateWithNoparma('/form-api/components/widgets').then(data2 => {
          data2.forEach(d2 => {
            let parentCategory = data.find(d => d.id === d2['component_category_id']) // 控件所属类
            if (parentCategory && parentCategory.components && !parentCategory.components.find(e => e.id === d2.id)) {
              parentCategory.components.push({
                id: d2.id,
                imgSrc: d2['img_src'],
                name: d2.NAME,
                type: d2.type
              })
            }
          })
          data.forEach(m => {
            m.components.forEach(n => {
              if (n.imgSrc.indexOf('data:image/png;base64,') > -1) {
                // 保存一次图片会变成base64格式,需要特殊处理
                n.imgSrc = n.imgSrc
              } else if (n.imgSrc) {
                n.imgSrc = require(`${n.imgSrc}`)
              }
            })
          })
          this.templateCategories = data
          this.activeNames.push(this.templateCategories[0].name)
        })
      })
    },
    // 搜索打开折叠面板
    getSearchControls (templateCategories, searchKeyword) {
      // 需要展开折叠面板的数组重新赋值
      this.activeNames = []
      templateCategories.forEach(element => {
        // 当前类别的控件组是否有关键字，有关键字的话就去这个控件组取每个控件
        if (element.components.find(value => value.name.indexOf(searchKeyword) > -1)) {
          this.activeNames.push(element.name)
        }
        this.keyword = searchKeyword
      })
    },
    closeSearchControls () {
      this.activeNames = []
    },
    onDragStart (event, template) {
      let transferData = {
        type: template.type,
        mouseOffset: {
          x: event.offsetX,
          y: event.offsetY,
          width: event.target.offsetWidth,
          height: event.target.offsetHeight
        }
      }
      event.dataTransfer.setData('transferData', JSON.stringify(transferData))
    },
    // 递归查找符合条件的布局控件
    findLayoutComponent (components) {
      for (let i in components) {
        if ((components[i].id === this.highlightId || !this.highlightId) && components[i].componentType === 'rc-layout') {
          this.currentLayoutComponet = components[i]
          break
        } else if (components[i].children && components[i].children.length > 0) {
          this.findLayoutComponent(components[i].children)
        }
      }
    },
    // 双击添加控件
    addComponentByDB (template) {
      // 排除容器控件
      if (['rc-layout', 'rc-draggable', 'rc-table', 'rc-group'].some(item => item === template.type)) {
        return false
      }
      if (this.formService.component && this.formService.component.children.length !== 0) {
        // 如果有当前节点的表单信息说明是流程,查找当前节点表单
        if (this.currentNodeFormId) {
          let currentNodeForm = this.formService.component.children.filter(e => e.id === this.currentNodeFormId)
          currentNodeForm && this.findLayoutComponent(currentNodeForm)
        } else {
          this.findLayoutComponent(this.formService.component.children)
        }
      }
      // 判断有没有布局控件
      if (this.currentLayoutComponet) {
        // 找到这个布局控件的实例,使用他的增加子组件的方法
        let shortestDraggable
        this.currentLayoutComponet.children.forEach(e => {
          if (!shortestDraggable) {
            shortestDraggable = e
          } else if (e.children.length < shortestDraggable.children.length) {
            shortestDraggable = e
          }
        })
        // 通过 findAllVue 找到当前这个 draggable 组件的实例
        let shortestDraggableComponent
        shortestDraggableComponent = shortestDraggable && this.findAllVue2(this.$parent).find(e => e.initComponent && e.initComponent.componentId === shortestDraggable.componentId)
        // 调用他的addComponet方法
        shortestDraggableComponent && shortestDraggableComponent.addComponent({componentType: template.type, componentName: template.name})
      }
    }
  }
}
</script>

<style lang="scss">
.component-list {
  .component-ul li{
    position: relative;
    .component-template{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      span.name{
        display: block;
        font-size: 12px;
      }
    }
  }
  .seach-input {
    padding: 10px 16px;
    position: relative;
    .input-with-select >input {
      padding-left: 24px;
    }
    .search {
     position: absolute;
     left:26px;
     top: 50%;
     margin-top: -7px;
    }
  }
  .el-collapse{
    padding:0 16px;
    border:none;
    .el-collapse-item__header{
      border-bottom: none;
    }
     .el-collapse-item__arrow {
        float: left;
    }
    .el-collapse-item__content{

      padding-bottom: 0;

    .component-ul{
      overflow: hidden;
       .component-template{
          float: left;
          width: 33%;
          text-align: center;
          padding-bottom: 14px;
          padding-top: 14px;
          border-radius: 4px;
         li.component-template{
           width: 100%;
           z-index: 10;
         }
         li.component-template:hover{
           background: none;
         }
          img {
            width: 12px;
            height: 12px;
            margin-bottom: 12px;
          }
          span.name {
            color: #363636;
            display: block;
            font-size: 12px;
          }
           &:hover{
               background-color: #d1e9fe
           }
       }
    }
   }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/design/component-list.vue